import types from './types';

const setBillingInfo = (billingInfo) => ({
    type: types.SET_BILLING_INFO,
    payload: billingInfo
});

const setLoading = (loading) => ({
    type: types.SET_LOADING,
    payload: loading
});

const resetBillingInfo = () => ({ type: types.RESET_BILLING_INFO });

export default {
    setBillingInfo,
    setLoading,
    resetBillingInfo
};
